import { render } from "./NewsletterRegister.vue?vue&type=template&id=6671ef78"
import script from "./NewsletterRegister.vue?vue&type=script&lang=js"
export * from "./NewsletterRegister.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__